import { parseOnlyNumericValue, safeToString, sliceText } from "../../../utils/common";





export const PTAX_INITIAL_STATE={


 
  status:null,
  ptax_ec_code:"",
  ptax_rc_code:"",
  financial_year:"",
  state:""

}

export const TAX_INPUT_FIELDS = {
  status: {
    name: "status",
    label: "Disable P-Tax Status",
    type: "checkbox",
    color:"Primary",
    size:"lg",
    lableFirst:true,
  },
  ptax_ec_code: {
    name: "ptax_ec_code",
    label: "P-TAX(EC) Code",
    type: "text",
    placeholder: "Type Here...",
    fullWidth: true,
    required:true,
    customOptions: {
      formatValueFn:(value)=>{   
        return sliceText(parseOnlyNumericValue(safeToString(value)),12);
     }
      
      }

  },
  
  ptax_rc_code: {
    name: "ptax_rc_code",
    label: "P-TAX(RC) Code",
    type: "text",
    placeholder: "Type Here...",
    fullWidth: true,
    required:true,
    customOptions: {
           formatValueFn:(value)=>{   
             return sliceText(parseOnlyNumericValue(safeToString(value)),12);
          }
           
           }

  },

  financial_year: {
    name: "financial_year",
    label: "Financial Year",
    type: "select",
    required:true,

    placeholder: "Select Here...",
    fullWidth: true,
  },

  state: {
    name: "state",
    label: "State",
    type: "select",
    required:true,
    placeholder: "Select Here...",
    fullWidth: true,
    options: [
      { id: "westbengal", name: "West Bengal" },
      { id: "odisa", name: "Odisa" },
    ],
  },
};


export const PTAX_API={
  PTAX_CREATE:{url:"organization/org-ptax", method:"POST"},
  ESI_UPDATE:{URL:"organization/org-ptax", METHOD:"PATCH"},
  ESI_DELETE:{URL:"organization/org-ptax", METHOD:"DELETE"},
  ORGANIZATION_PTAX_GET:{url:"organization/org-ptax", method:"GET"},
  PTAX_LIST:{URL:"/admin/p-tax/", METHOD:"GET"},
  MASTER_ESI_LIST:{URL:"organization/org-ptaxadmin/master", METHOD:"GET"},
  
  };
